import { z } from 'zod';
import { MakeCloudFunctionSpec } from '@rabbit/firebase/doctype';

/* -------------------------------------------------------------------------- */
/*                               Get the lexicon                              */
/* -------------------------------------------------------------------------- */

const ICF_GetLexicon = z.object({
  id: z.string(),
});

const OCF_GetLexicon = z.object({
  body: z.record(z.string()),
});

export const CFC_GetLexicon = MakeCloudFunctionSpec(
  'api/legacy/cfcgetlexicon',
  ICF_GetLexicon,
  OCF_GetLexicon
);

const ICF_GetLabels = z.object({
  tenantLink: z.string(),
});

const Z_Label = z.object({
  key: z.string(),
  label: z.string(),
  tenantLink: z.string(),
  createdBy: z.string(),
  docid: z.string(),
});

const OCF_GetLabels = z.object({
  body: z.array(Z_Label),
});

export const CFC_GetLabels = MakeCloudFunctionSpec(
  'api/legacy/cfcgetlabels',
  ICF_GetLabels,
  OCF_GetLabels
);
